import BaseClass from "../../libs/base/BaseClass";
import Util from "../../libs/util/Util";

/**
 * top.jsonの制御・管理
 */
export default class GetApiMasterDataClass extends BaseClass{
    constructor(){
        super();
        this.name = "GetApiMasterDataClass";
    }

    /**
     * top.jsonを取得
     * @param {String} _api
     * @param {Function} _callback
     * @example
     * GetApiMasterDataClass.getMasterTicketData(url,(_data)=>{});
     */
    static getMasterTicketData(_api,_callback){
        let masterData = Util.sessionStorageGetItem(Util.SESSION_KEY_MASTER_AIRPLANE_TICKET);
        if(masterData){
            const tmpData = JSON.parse(masterData);
            const create_at = new Date(tmpData.create_at);
            const now = new Date();
            //console.log(create_at);
            if(create_at.getHours() < 17 && now.getHours() >= 17) masterData = null;
        }
        //console.log(masterData);

        if(masterData){
            Util.MASTER_AIRPLANE_TICKET = JSON.parse(masterData);
            GetApiMasterDataClass.createMasterData();
            if(_callback) _callback();
        } else {
            Util.apiCall({url:_api},//"./data/top.json"},
                (_data)=>{
                    if(_data){
                        //console.log(_data);
                        _data.create_at = new Date();
                        Util.sessionStorageSetItem(Util.SESSION_KEY_MASTER_AIRPLANE_TICKET, JSON.stringify(_data));
                        Util.MASTER_AIRPLANE_TICKET = _data;
                        GetApiMasterDataClass.createMasterData();
                    }
                    if(_callback) _callback(_data);
                }/*,
                (a,b,c)=>{
                    console.log("GetApiMasterTicketDataClass api 読み込みエラー",a,b,c);
                    if(_callback) _callback();
                }*/
            );
        }
    }

    /**
     * top.jsonを整理
     * @example
     * GetApiMasterDataClass.createMasterData();
     */
    static createMasterData(){
        const getdomesticairport = $.extend([],Util.MASTER_AIRPLANE_TICKET.getdomesticairport.item);

        // TYO：東京(羽田・成田)とOSA：大阪(伊丹・関西) はマスタにないので補完する。
        let tyo = {};
        let osa = {};

        let tyoArrlist = {};
        let nrtArrlist = {};
        let osaArrlist = {};
        let kixArrlist = {};
        for (let j in getdomesticairport) {
            if (getdomesticairport[j]['code'] === '998' || getdomesticairport[j]['code'] === 'TYO') {
                tyo = getdomesticairport[j];
                tyo.code = 'TYO';
            }
            if (getdomesticairport[j]['code'] === '999' || getdomesticairport[j]['code'] === 'OSA') {
                osa = getdomesticairport[j];
                osa.code = 'OSA';
            }
            if (getdomesticairport[j]['code'] === 'HND') {
                tyoArrlist = getdomesticairport[j]['arrlist'] === undefined ? {} : getdomesticairport[j]['arrlist'];
            }
            if (getdomesticairport[j]['code'] === 'NRT') {
                nrtArrlist = getdomesticairport[j]['arrlist'] === undefined ? {} : getdomesticairport[j]['arrlist'];
            }
            if (getdomesticairport[j]['code'] === 'ITM') {
                osaArrlist = getdomesticairport[j]['arrlist'] === undefined ? {} : getdomesticairport[j]['arrlist'];
            }
            if (getdomesticairport[j]['code'] === 'KIX') {
                kixArrlist = getdomesticairport[j]['arrlist'] === undefined ? {} : getdomesticairport[j]['arrlist'];
            }
        }
        tyo.arrlist = { arritem: [{ code: osa.code, namej: osa.namej, areacode: osa.areacode, disp_name: osa.disp_name }] };
        osa.arrlist = { arritem: [{ code: tyo.code, namej: tyo.namej, areacode: tyo.areacode, disp_name: tyo.disp_name }] };

        tyo['arrlist'] = GetApiMasterDataClass.mergeAirport(tyoArrlist, nrtArrlist,getdomesticairport,tyo);
        osa['arrlist'] = GetApiMasterDataClass.mergeAirport(osaArrlist, kixArrlist,getdomesticairport,osa);

        let airportData = {};
        for(let k in getdomesticairport){
            const d = getdomesticairport[k];
            airportData[d.code] = d;
        }
        //console.log("---airpotData:",airportData);
        Util.MASTER_AIRPORT_DATA = airportData;

        let priceList = {};
        const price = $.extend([],Util.MASTER_AIRPLANE_TICKET.price);
        for(let k in price){
            const d = price[k];
            if(!priceList[d.dep_code]) priceList[d.dep_code] = {};
            if(!priceList[d.dep_code][d.obj_code]) priceList[d.dep_code][d.obj_code] = {};
            priceList[d.dep_code][d.obj_code][d.date] = d;
        }
        Util.MASTER_AIRPLANE_PRICE_LIST = priceList;
        //console.log("---priceList:",priceList);
    }

    static mergeAirport(arr1,arr2,getdomesticairport,obj) {
        let arr_target_code = [];
        let arr_target = obj.arrlist.arritem;
        obj.arrlist.arritem.forEach((currentValue) => { arr_target_code.push(currentValue.code); });
        if (arr1 && arr1.arritem && Array.isArray(arr1.arritem)) {
            arr1.arritem.forEach(element => {
                if (!arr_target_code.includes(element.code)) {
                    arr_target_code.push(element.code);
                    arr_target.push(element);
                }
            });
        }
        if (arr2 && arr2.arritem && Array.isArray(arr2.arritem)) {
            arr2.arritem.forEach(element => {
                if (!arr_target_code.includes(element.code)) {
                    arr_target_code.push(element.code);
                    arr_target.push(element);
                }
            });
        }

        for (let j in getdomesticairport) {
            if (arr_target_code.includes(getdomesticairport[j].code)
                && !getdomesticairport[j].arrlist.arritem.find(item => item.code === obj.code)) {
                getdomesticairport[j].arrlist.arritem.push({ code: obj.code, namej: obj.namej, areacode: obj.areacode, disp_name: obj.disp_name });
            }
        }
        return { arritem: arr_target };
    }

}